import { useFormContext, useFormField } from '@calendly/form';
import { useCalendarData } from '@calendly/ui/hooks/use-calendar-data';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { useState, forwardRef } from 'react';
import Calendar from 'components/availability/form/calendar_view/calendar';
import Navigation from 'components/availability/form/calendar_view/navigation';
import { getBookingRangeInitialValues } from 'components/event_type_edit';
import { Layout } from 'components/layout';
import { useEventType } from 'features/event_type_provider';
import { getEventTypePeriodEnd, getEventTypePeriodStart } from 'selectors/availability/schedules';
import { TimezoneDropdown } from '../../timezone_dropdown';
const controlRowCss = "c10zdoag";
const ControlRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(controlRowCss, props.className)} />;
});
const CalendarControls = props => <Layout gap="16" justify="space-between" grow align="center" paddingTop="24" {...props} />;
const calendarContainerCss = "c1xp817f";
const CalendarContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(calendarContainerCss, props.className)} />;
});
export const AvailabilityCalendar = ({
  formPath
}) => {
  const {
    setFieldValue
  } = useFormContext();
  const [{
    value: {
      availableHours,
      timezone,
      dateOverrides
    }
  }] = useFormField({
    name: formPath
  });
  const setDateOverrides = overrides => setFieldValue(`${formPath}.dateOverrides`, overrides);
  const setAvailableHours = hours => setFieldValue(`${formPath}.availableHours`, hours);
  const [{
    value: holidays
  }] = useFormField({
    name: `${formPath}.holidays`
  });
  const [{
    value: userHolidaySet
  }] = useFormField({
    name: `${formPath}.userHolidaySet`
  });
  const setUsingCustomHours = () => {
    setFieldValue(`${formPath}.usingCustomHours`, true);
    setFieldValue(`${formPath}.usingSecondarySchedule`, false);
  };
  const onDatesUpdated = overrides => {
    setUsingCustomHours();
    setDateOverrides(overrides);
  };
  const setWdayIntervals = (day, intervals) => {
    const updatedHours = {
      ...availableHours,
      [day]: intervals
    };
    setUsingCustomHours();
    setAvailableHours(updatedHours);
  };
  const now = moment().tz(timezone).format('YYYY-MM');
  const yearFromNow = moment().tz(timezone).add(1, 'year').format('YYYY-MM');
  const [currentMonthId, setCurrentMonthId] = useState(now);
  const {
    title,
    weekdays,
    weeks,
    nextMonthId,
    prevMonthId,
    isCurrentMonth
  } = useCalendarData(currentMonthId, timezone);
  const eventType = useEventType();
  const {
    periodType,
    startDate,
    movingType,
    maxBookingTime,
    endDate
  } = getBookingRangeInitialValues(eventType);
  const activeFrom = getEventTypePeriodStart(periodType, startDate, timezone);
  const activeTo = getEventTypePeriodEnd(periodType, movingType, maxBookingTime, endDate, timezone);
  return <>
      <ControlRow>
        <CalendarControls>
          <Layout align="center">
            <Navigation isCurrentMonth={isCurrentMonth} isLastMonth={nextMonthId === yearFromNow} setMonth={setCurrentMonthId} prevMonthId={prevMonthId} nextMonthId={nextMonthId} title={title} useUpdatedStyles alternateStyling />
          </Layout>
          <TimezoneDropdown formPath={formPath} expandLeft />
        </CalendarControls>
      </ControlRow>
      <CalendarContainer>
        <Calendar allowWdayUpdates days={availableHours} dates={dateOverrides} holidays={holidays} userHolidaySet={userHolidaySet} timezone={timezone} weekdays={weekdays} weeks={weeks} setDates={onDatesUpdated} setHolidays={() => {}} setUserHolidaySet={() => {}} setWdayIntervals={setWdayIntervals} activeFrom={activeFrom} activeTo={activeTo} activeWeekends={periodType !== 'rollingDays' || movingType !== 'business'} isFullHeight useUpdatedStyles readOnlyHolidays horizontalSpacers />
      </CalendarContainer>
    </>;
};

require("./availability_calendar.wyw-in-js.css!=!../../../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./availability_calendar.js");